export default __webpack_public_path__ + "static/media/640_store04-es-mobile.3581c165.png";